import http from './http';
import { listResource } from './listResource';

export async function listClientSubcriptions(options = {}) {
  return listResource('/client-subscriptions', options);
}

/**
 * Obtiene un suscripción por su ID.
 */
export async function getClientSubscriptionById(id) {
  const res = await http.get(`/client-subscriptions/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Crea un nuevo suscripción.
 */
export async function createClientSubscription(data) {
  const res = await http.post('/client-subscriptions', data);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza un suscripción.
 */
export async function updateClientSubscription(id, data) {
  const res = await http.put(`/client-subscriptions/${id}`, data);
  return res.data?.data ?? res.data;
}

/**
 * Activar/Desactivar suscripción
 */
export const updateClientSubscriptionStatus = (id, status) =>
  // eslint-disable-next-line camelcase
  http.patch(`/client-subscriptions/${id}/status`, { status: status });

/**
 * Eliminar suscripción
 */
export const deleteClientSubscription = (id) => http.delete(`/client-subscriptions/${id}`);

/**
 * Reenviar invitación de activación
 */
export const resendActivation = (id) => http.post(`/client-subscriptions/${id}/resend-activation`);